import YoungPersonAssignHouseModalView from './YoungPersonAssignHouseModalViewContainer';
export default YoungPersonAssignHouseModalView;
